import { AuthProvider, ProtectRoute } from './AuthContext';
import { LeaveProvider } from './LeaveContext';
import { NotificationProvider } from './NotificationContext';

const AppContext = ({ children }: { children: React.ReactNode }) => (
  <AuthProvider>
    <NotificationProvider>
      <LeaveProvider>
        <ProtectRoute>{children}</ProtectRoute>
      </LeaveProvider>
    </NotificationProvider>
  </AuthProvider>
);
export default AppContext;
